import * as XLSX from "xlsx";
export const formatDate = (date: string) => {
  const inputDate: Date = new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat(
    "en-GB",
    options
  );
  const formattedDate: string = formatter.format(inputDate);

  return formattedDate;
};

export const isValidDomain = (domain: string) =>
  /^(?:[-A-Za-z0-9]+\.)+[A-Za-z]{2,6}$/.test(domain);

export const isValidEmail = (email: string) =>
  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);

export const generateExcel = (data: Object[]) => {
  const workSheet = XLSX.utils.json_to_sheet(data);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, "Error Report");
  XLSX.writeFile(workBook, "error_report.xlsx");
};

export const generateCSV = function (data: Object[]) {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(","));

  for (const row of data) {
    const values = headers.map((header) => {
      const val = row[header];
      return `"${val}"`;
    });
    csvRows.push(values.join(","));
  }
  return csvRows.join("\n");
};
